export const DRONA_TRACKING_TYPES = {
  dronaMeetingJoinClick: 'drona_meeting_join_click',
  dronaMeetingNotFoundView: 'drona_meeting_not_found_view',
  dronaHelpButtonClick: 'drona_help_button',
  dronaFullScreenButtonClick: 'drona_full_screen_button',
  dronaRaiseHandClick: 'drona_raise_hand',
  dronaDisableIncomingVideo: 'drona_disable_incoming_video_button_click',
  dronaNetworkSpeed: 'drona_connectivity_setting',
  dronaDeleteBookmark: 'drona_delete_bookmark',
  dronaBookmarkTabClick: 'drona_bookmark_tab',
  dronaAddBookmarkClick: 'drona_add_bookmark',
  dronaReactionDisableSettingsButton: 'drona_reaction_disabled_settings_button',
  dronaScreenShareButtonClick: 'drona_screen_share',
  dronaScreenShareStartedLog: 'drona_screen_share_started_log',
  dronaLaunchQuizButtonClick: 'drona_launch_a_quiz',
  dronaLaunchClonedQuizClick: 'drona_launch_cloned_quiz',
  dronaEditClonedQuizClick: 'drona_edit_cloned_quiz',
  dronaLaunchQuizNowClick: 'drona_launch_quiz_now',
  dronaSaveQuizLaterClick: 'drona_saved_later_quiz',
  dronaLaunchPollButtonClick: 'drona_launch_a_poll',
  dronaLaunchClonedPollClick: 'drona_launch_cloned_poll',
  dronaEditClonedPollClick: 'drona_edit_cloned_poll',
  dronaLaunchPollNowClick: 'drona_launch_poll_now',
  dronaSavePolLaterClick: 'drona_save_later_poll',
  dronaInMeetingSettingsButton: 'drona_in_meeting_settings_button_click',
  dronaCloseChatClick: 'drona_close_chat_pop_up',
  dronaOpenChatClick: 'drona_open_chat_tab',
  dronaOpenNoticeBoardClick: 'drona_open_notice_board_click',
  dronaNotifyChatDropdownClick: 'drona_chat_drop_down',
  dronaBecomeAudienceClick: 'drona_become_audience',
  dronaBecomeHostClick: 'drona_become_host',
  dronaChatReactionClick: 'drona_reaction_button_in_chat',
  dronaSendChatMessage: 'drona_send_message_button',
  dronaAskQuestionButtonClick: 'drona_ask_question_button',
  dronaPostQuestionButtonClick: 'drona_post_question_button',
  dronaEndCallButtonClick: 'drona_end_call_button',
  dronaEndCallProceedButtonClick: 'drona_end_call_proceed',
  dronaRecordMeetingButtonClick: 'drona_record_meeting',
  dronaEndCallCancelButtonClick: 'drona_end_call_cancel',
  dronaViewLeaderboardClick: 'drona_view_leaderboard',
  dronaPinnedMessagesDropdownClick: 'drona_pinned_messages',
  dronaPinnedMessageAddClick: 'drona_pinned_message',
  dronaPinnedMessageLinkClick: 'drona_pinned_message_link',
  dronaMeetingJoinAsClick: 'drona_meeting_join_as_click',
  dronaSettingsClick: 'drona_settings_click',
  dronaAudioToggleClick: 'drona_audio_toggle_click',
  dronaVideoToggleClick: 'drona_video_toggle_click',
  dronaSystemCheckClick: 'drona_system_check_click',
  dronaPreMeetingJoinView: 'drona_pre_meeting_join_view',
  platformFeedbackSubmitted: 'drona_feedback_form_submitted',
  platformFeedbackOpened: 'drona_feedback_form_opened',
  platformFeedbackSubmitError: 'drona_feedback_submission_error',
  dronaGenericNudgeView: 'drona_generic_nudge_view',
  dronaGenericNudgeClosed: 'drona_generic_nudge_closed',
  dronaGenericNudgeInteracted: 'drona_generic_nudge_acknowledge',
  dronaNoticeBoardChatBanner: 'drona_notice_board_chat_banner_click',
  dronaNoticeBoardItemClick: 'drona_notice_board_item_click',
  dronaNoticeBoardArrowStripClick: 'drona_notice_board_arrow_strip_click',
  dronaNoticeBoardAddButtonClick: 'drona_notice_board_add_button_click',
  dronaNoticeBoardDeleteMessageClick: 'drona_notice_board_delete_message_click',
  dronaNoticeBoardLinkClick: 'drona_notice_board_link_click',
  dronaNoticeBoardModalClose: 'drona_notice_board_modal_close',
  dronaNoticeBoardPinMessageClick: 'drona_notice_board_pin_message_click',
  dronaNoticeBoardPinMessageTemplateClick:
    'drona_notice_board_pin_message_template_click',
  dronaNoticeBoardPopupClick: 'drona_notice_board_popup_click',
  dronaNoticeBoardEventCardClick: 'drona_notice_board_event_card_click',
  dronaNoticeBoardEventCardErrorView: 'drona_notice_board_event_error_view',
  dronaNoticeBoardEventCardSuccessView: 'drona_notice_board_event_success_view',
  dronaNoticeBoardTabToggleClick: 'drona_notice_board_tab_toggle_click',
  dronaNoticeBoardBannerListTemplateView:
    'drona_notice_board_banner_list_template_view',
  dronaWindowUnloadTracking: 'drona_window_unload_tracking',
  dronaSwitchQuestionTab: 'drona_switch_question_tab',
  dronaAutoResponseGotItClick: 'drona_auto_response_got_it',
  dronaAutoResponseAnswerGenerated: 'drona_autoresp_ans_generated',
  dronaAutoResponseAnswerApprovedByLearner:
    'drona_autoresp_ans_learner_apporved',
  dronaAutoResponseAnswerDisapprovedByLearner:
    'drona_autoresp_ans_learner_disapproved',
  dronaAutoResponseAnswerApprovedByInstructor:
    'drona_autoresp_ans_instructor_apporved',
  dronaAutoResponseAnswerDisapprovedByInstructor:
    'drona_autoresp_ans_instructor_disapproved',
  dronaQuestionAnswerNowClick: 'drona_question_answernow',
  dronaQuestionMarkAsAnsweredClick: 'drona_question_mark_answered',
  dronaQuestionWithdrawQuestion: 'drona_question_withdraw_my_question',
  dronaProxyChatButtonClick: 'drona_custom_chat_popup',
  dronaProxyChatRandomiseNameClick: 'drona_custom_chat_randomise_name',
  dronaProxyChatRandomiseMessageClick: 'drona_custom_chat_randomise_message',
  dronaProxyChatSendCtaClick: 'drona_custom_chat_send_cta',
  dronaProxyChatPopupCloseClick: 'drona_custom_chat_popup_close',
  dronaProxyChatTabChangeClick: 'drona_custom_chat_tab_switch',
  dronaProxyChatSelectMessageClick: 'drona_custom_chat_select_message',
  dronaCueBasedChatTriggerReminderView:
    'drona_cue_based_chat_trigger_reminder_view',
  dronaCueBasedChatTriggerReminderClick:
    'drona_cue_based_chat_trigger_reminder_click',
  dronaProxyQuestionButtonClick: 'drona_custom_question_popup',
  dronaProxyQuestionPopupCloseClick: 'drona_custom_question_popup_close',
  dronaProxyQuestionRandomiseNameClick: 'drona_custom_question_randomise_name',
  dronaProxyQuestionSendCtaClick: 'drona_custom_question_send_cta',
  dronaProxyQuestionTabChangeClick: 'drona_custom_question_tab_switch',
  dronaMeetingHighResolutionLog: 'drona_meeting_high_resolution_log',
};

export const DRONA_SOURCES = {
  meetingTopNavBar: 'meeting_top_nav_bar',
  meetingModalPopUp: 'meeting_modal_pop_up',
  meetingRightSideDock: 'meeting_right_dock',
  meetingChatWindow: 'meeting_chat_window',
  meetingFooter: 'meeting_footer',
  meetingPreJoinModal: 'meeting_pre_join_modal',
  meetingVideoCard: 'meeting_video_card',
  meetingBottomPanel: 'meeting_bottom_panel',
  meetingSettingsPanel: 'meeting_settings_panel',
  meetingBookmarkModal: 'meeting_bookmark_modal',
  meetingRecording: 'meeting_recording',
  meetingMissingBookmarks: 'meeting_missing_bookmarks',
  meetingVideoPlayerControls: 'meeting_video_player_controls',
  meetingQuizModal: 'meeting_quiz_modal',
  meetingPollsModal: 'meeting_polls_modal',
  meetingMobileView: 'meeting_mobile_view',
  meetingQuestionInput: 'meeting_question_input',
  meetingEndModal: 'meeting_end_modal',
  onDronaNudges: 'on_drona_nudges',
  meetingChatWindowNoticeBoard: 'meeting_chat_window_noticeboard',
  meetingNoticeBoardTab: 'meeting_notice_board_tab',
  meetingNoticeBoardModal: 'meeting_notice_board_modal',
  meetingWindowUnload: 'meeting_window_unload',
  meetingQuestionView: 'meeting_question_view',
  meetingProxyChatModal: 'meeting_custom_chat_modal',
  meetingProxyQuestionModal: 'meeting_custom_question_modal',
};

export const DRONA_FEATURES = {
  meetingJoinFlow: 'meeting_join_flow',
  cueCards: 'cue_cards',
  quiz: 'quiz',
  poll: 'poll',
  chat: 'chat',
  meetingControls: 'meeting_controls',
  meetingRecording: 'meeting_recording',
  meetingSettings: 'meeting_settings',
  platformFeedback: 'meeting_platform_feedback',
  pinnedMessage: 'chat_pinned_message',
  video: 'video',
  troubleshooting: 'troubleshooting',
  bookmark: 'bookmark',
  leaderboard: 'leaderboard',
  screenShare: 'screen_share',
  roleSwitch: 'role_switch',
  reactions: 'reactions',
  questions: 'question',
  end_call: 'end_call',
  noticeBoard: 'notice_board',
  meetingUnload: 'meeting_unload',
  botResponse: 'bot_response',
  habitBuildingNudgeLive: 'habit_building_nudge_live',
  habitBuildingNudgeRecording: 'habit_building_nudge_recording',
  proxyCustomChat: 'custom_chat',
  proxyGenericChat: 'generic_chat',
  proxyCueBasedChat: 'cue_based_chat',
  proxyCustomQuestion: 'custom_question',
  videoBroadcasting: 'video_broadcasting',
};
